import { Container, Row, Col } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import Lottie from "react-lottie";
import * as errorDialog from "../assets/images/error-dialog.json";
import { loginRequest } from "../authConfig";
import {
  AccessError,
  accessErrorTexts,
  clearLoginError,
} from "../helpers/accessError";

const errorDialogOptions = {
  loop: true,
  autoplay: true,
  animationData: errorDialog,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

// Full-page message when a signed-in (or signing-in) user cannot use the portal.
export const AccessErrorPage = ({ error }: { error: AccessError }) => {
  const { instance, accounts } = useMsal();
  const text = accessErrorTexts[error.code];
  const account = accounts[0];

  // Entra ID errors need a fresh interactive sign-in; API errors only need the profile to be loaded again.
  const isSignInError =
    error.code.startsWith("ENTRA_") || error.code === "SIGN_IN_FAILED";

  const retry = () => {
    clearLoginError();
    if (account && !isSignInError) {
      // Reload the same page so the user keeps the route (e.g. /service or a deep link).
      window.location.reload();
    } else {
      instance.loginRedirect(loginRequest).catch(() => undefined);
    }
  };

  const useAnotherAccount = () => {
    clearLoginError();
    sessionStorage.clear();
    if (account) {
      instance
        .logoutRedirect({
          account,
          postLogoutRedirectUri: window.location.origin,
        })
        .catch(() => undefined);
    } else {
      instance
        .loginRedirect({ ...loginRequest, prompt: "select_account" })
        .catch(() => undefined);
    }
  };

  return (
    <Container>
      <Row>
        <Col>
          <div className="page-access-error text-center">
            <Lottie options={errorDialogOptions} height={160} width={160} />
            <h4>{text.title}</h4>
            <h6 className="text-muted">{text.titleEn}</h6>
            <p>
              {text.message}
              <br />
              <small className="text-muted">{text.messageEn}</small>
            </p>
            {(account?.username || error.reference) && (
              <div className="access-error-reference">
                {account?.username && <div>บัญชี: {account.username}</div>}
                {error.reference && <div>รหัสอ้างอิง: {error.reference}</div>}
              </div>
            )}
            <div className="access-error-actions">
              <button
                type="button"
                className="btn btn-primary-hr"
                onClick={retry}
              >
                ลองใหม่อีกครั้ง
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={useAnotherAccount}
              >
                {account
                  ? "ออกจากระบบ / ใช้บัญชีอื่น"
                  : "เข้าสู่ระบบด้วยบัญชีอื่น"}
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
